import * as React from 'react';
import { Button as FButton } from '@fluentui/react-components';

export const Button = ({ text, ...ButtonProps }: any) => (
  <FButton {...ButtonProps}>{text}</FButton>
);